import { AnyAction } from 'redux';

import type { OrderRetrieveResponse } from '../../openapi/types';

import { QUERY_STATE } from '../../constants';
import * as con from '../constants';

const orderDetailState = {
  data: {} as OrderRetrieveResponse,
  loadQueryState: QUERY_STATE.WAITING,
};

export const orderDetail = (
  state = orderDetailState,
  action: AnyAction,
): typeof orderDetailState => {
  switch (action.type) {
    case con.ORDER_DETAIL_LOAD_WAITING:
      return {
        ...state,
        loadQueryState: QUERY_STATE.WAITING,
      };
    case con.ORDER_DETAIL_LOAD_SUCCESS:
      return {
        ...state,
        data: action.data,
        loadQueryState: QUERY_STATE.SUCCESS,
      };
    case con.ORDER_DETAIL_LOAD_FAILURE:
      return {
        ...state,
        loadQueryState: QUERY_STATE.FAIL,
      };
    case con.ORDER_INTERRUPT_PROCESSING_SUCCESS:
    case con.ORDER_RETRY_PROCESSING_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          state: action.data.state,
        },
      };
    default:
      return state;
  }
};
